/**
 * @file Verify Email Page — /verify-email?token=...
 */
import React, { useEffect, useState } from "react";
import { useSearchParams, Link as RouterLink } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { authService } from "../services/auth";
import AuthShell from "../components/AuthShell";
import { Button, Spinner } from "../ui";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      return;
    }
    authService
      .verifyEmail(token)
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, [token]);

  if (status === "loading") {
    return (
      <AuthShell title="Verificando tu correo">
        <div className="auth-status">
          <Spinner size={28} />
          <p>Un momento por favor...</p>
        </div>
      </AuthShell>
    );
  }

  if (status === "success") {
    return (
      <AuthShell>
        <div className="auth-status">
          <CheckCircle2 size={48} className="auth-status-ok" />
          <h2 className="auth-status-title">¡Correo verificado!</h2>
          <p>Tu cuenta está lista. Ya puedes iniciar sesión y configurar tu perfil.</p>
          <Button asChild size="lg" fullWidth>
            <RouterLink to="/login">Iniciar sesión</RouterLink>
          </Button>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell>
      <div className="auth-status">
        <XCircle size={48} className="auth-status-err" />
        <h2 className="auth-status-title">Enlace inválido</h2>
        <p>Este enlace ya fue usado o expiró. Intenta iniciar sesión directamente.</p>
        <Button asChild size="lg" fullWidth>
          <RouterLink to="/login">Ir al inicio de sesión</RouterLink>
        </Button>
      </div>
    </AuthShell>
  );
}
